import { FirestoreSharedResourceMediaType } from '@/types/firestore/shared';

export const BRAND_NAME = '1440';
export const SITE_TITLE = '1440';
export const SITE_PUBLISHER_NAME = '1440 Media';
export const SITE_BUSINESS_NAME = '1440 Media, LLC';
export const SITE_DESCRIPTION =
  'Quickly find and learn from the best content on the internet, curated by the editorial team at 1440.';
export const SITE_PROD_URL = 'join1440.com';

export const ENV_BASED_SITE_TITLE =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
    ? `[DEV] ${SITE_TITLE}`
    : SITE_TITLE;

function getSiteURL() {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    return `https://${SITE_PROD_URL}`;
  }

  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview') {
    return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`;
  }

  return 'http://localhost:3000';
}

export const API_URL = process.env.NEXT_PUBLIC_FETCH_API_URL;
export const SITE_BASE_URL = getSiteURL();

export const YOUTUBE_CHANNEL_ID = 'UCh-ymsgOsy79CLOfSHz5z5A';
export const RECAPTCHA_ACTION_NAME_SUBSCRIBE = 'subscribeFormKh';
export const RECAPTCHA_ACTION_NAME_CONTACT = 'contactFormKh';
export const RECAPTCHA_ACTION_NAME_SURVEY = 'surveyFormKh';
export const RECAPTCHA_ACTION_NAME_PREFERENCES = 'preferencesFormKh';
export const RECAPTCHA_ACTION_NAME_JOIN_MORE = 'joinMoreFormKh';

export const HOMEPAGE_POPULAR_PARENT_TOPIC_SLUGS = [
  'health-and-medicine',
  'world-history',
  'space',
  'space-science',
  'technology',
  'business-and-finance',
];

export const SEARCH_UI_POPULAR_TOPICS: { name: string; slug: string }[] = [
  { name: "Alzheimer's", slug: 'alzheimers' },
  { name: 'Dreams', slug: 'dreams' },
  { name: 'Gut Microbiome', slug: 'gut-microbiome' },
  { name: 'Black Holes', slug: 'black-holes' },
  { name: 'LSD', slug: 'lsd' },
  { name: 'Generative AI', slug: 'generative-ai' },
  { name: 'Diabetes', slug: 'diabetes' },
  { name: 'Medieval History', slug: 'medieval-history' },
  { name: 'James Webb', slug: 'james-webb' },
  { name: 'Bitcoin', slug: 'bitcoin' },
];

export const MEDIA_LABELS = {
  article: 'Article',
  data_visualization: 'Data Visualization',
  interactive: 'Interactive',
  photography: 'Photography',
  podcast: 'Podcast',
  video: 'Video',
};

export const MEDIA_TYPES: {
  [key in FirestoreSharedResourceMediaType]: {
    name: string;
    ctaLabel?: string;
  };
} = {
  article: {
    name: 'Article',
    ctaLabel: 'Read',
  },
  data_visualization: {
    name: 'Data Visualization',
    ctaLabel: 'View data',
  },
  interactive: {
    name: 'Interactive',
    ctaLabel: 'Interact',
  },
  photography: {
    name: 'Photography',
    ctaLabel: 'View photo',
  },
  podcast: {
    name: 'Podcast',
    ctaLabel: 'Listen',
  },
  video: {
    name: 'Video',
    ctaLabel: 'Watch',
  },
  any: {
    name: 'Any',
  },
  none: {
    name: 'None',
  },
};

export const PATHS = {
  resources: 'resources',
  topics: 'topics',
  articles: 'articles',
  newsletter: 'newsletter',
};

export const UTM_SESSION_STORAGE_KEY = 'utmParams';

export const RELEVANT_1440_UTM_PARAMS = [
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_term',
  'utm_1440_exp',
  'gclid',
  'li_did',
];
